import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuComponent } from "../../components/menu/menu.component";
import { ApiService, CommonFunctionsService, DatastoreService } from '../../services';
import { NgxSpinnerService } from "ngx-spinner";
import moment from 'moment-timezone';

@Component({
  selector: 'app-checklist',
  templateUrl: './checklist.component.html',
  styleUrls: ['./checklist.component.scss']
})
export class ChecklistComponent implements OnInit {

  config: any;
  site: string = "";
  companyDetails: any;
  booking: any;
  service: any;
  purchase: any;
  schema: any;
  choicesData: any;
  choicesRequiredCount: number = 0;
  choicesFoundCount: number = 0;
  giveNoticeDueDate: string;
  outstandingBalanceDueDate: string;
  choicesDueDate: string;
  notice1Given: any = false;
  notice2Given: any = false;
  myUrl = '';
  excludedChoicesServiceIds: any[] = [];
  hideGiveNoticeServiceIds: any[] = [];

  constructor(
    private route: ActivatedRoute,
    private dataStore: DatastoreService,
    private commonFunctionsService: CommonFunctionsService,
    private apiService: ApiService,
    private spinner: NgxSpinnerService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(async params => {
      await this.commonFunctionsService.setCompanyName(params);
      this.site = params.site;

      // Relative path — resolves against the document <base href>
      // (`/` on staging, `/myceremony/` in prod), so the link stays on the
      // current host. Hardcoding `westminster.myceremony.bookinglab.co.uk`
      // sent prod customers to a non-resolving hostname.
      this.myUrl = `${params.site}/${params.comp}`;
    });
    this.booking = this.dataStore.booking;
    if (!this.booking) {
      const bookingStr = localStorage.getItem('ceremony') as string;
      this.booking = JSON.parse(bookingStr);
    }
    this.service = this.dataStore.selectedService;
    if (!this.service) {
      const serviceStr = localStorage.getItem('service') as string;
      this.service = JSON.parse(serviceStr);
    }
    const configStr = this.dataStore.config;
    const config = JSON.parse(configStr);
    this.config = config;
    console.log(config);
    this.setup();
  }

  async setup() {
    // get the purchase
    this.excludedChoicesServiceIds = this.dataStore.excludedChoicesServiceIds;

    // RWRSPI-989: hide the Give Notice checklist row for non-stat bookings.
    if (this.config.myCeremony.hasOwnProperty('give-notice')) {
      if (this.config.myCeremony['give-notice'].hasOwnProperty('rules')) {
        if (this.config.myCeremony['give-notice'].rules.hasOwnProperty('hideMenuFromServiceIds')) {
          this.hideGiveNoticeServiceIds = this.config.myCeremony['give-notice'].rules.hideMenuFromServiceIds;
        }
      }
    }

    try {
      this.purchase = await this.apiService.getPurchase(this.booking.company_id, this.booking.service_id, this.booking.purchase_id);
    }
    catch (err) {
      console.error(err);
    }

    try {
      this.schema = await this.apiService.getFormSchema(`ceremony_choices_${this.service.global_id}`);
      this.choicesData = await this.apiService.getMetadataForBooking(this.booking.company_id, this.booking.id, `ceremony_choices`);
    }
    catch (err) {
      console.error(err);
    }

    try {
      if (this.schema && this.choicesData) {
        if (this.choicesData && this.choicesData.Item && this.choicesData.Item.data) {
          for (const field of this.choicesData.Item.data) {
            const found = this.schema.schema.fields.find((f:any) => f.field == field.field);
            if (found) {
              if (found.required) {
                if (found.hasOwnProperty('trigger')) {
                  const trigger = this.schema.schema.fields.find((f:any) => f.field == found.field);
                  if (trigger) {// we only care about these fields if their trigger was set
                    // now find the value for the trigger
  
                    const triggerValue = this.choicesData.Item.data.find((f:any) => f.field == trigger.field);
                    if (triggerValue) {
                      if (triggerValue.length > 0) {
                        // NOW we care about this one!
                        this.choicesRequiredCount++;
                        if (field.value.length > 0) {
                          this.choicesFoundCount++;
                        }
                      }
                    }
                  }
                }
                else {
                  this.choicesRequiredCount++;
                  if (field.value.length > 0) {
                    this.choicesFoundCount++;
                  }
                }
              }
            }
          }
        }
        else {
         this.choicesRequiredCount = 1; // fake the counts to ensure the form is not marked as complete
        }
      }
      else {
       console.log('here');
      }
      console.log(this.choicesRequiredCount, this.choicesFoundCount);
    }
    catch (err) {
      console.error(err);
    }

    if (this.config.myCeremony.hasOwnProperty('ceremony-checklist')) {
      if (this.config.myCeremony['ceremony-checklist'].hasOwnProperty('outcomes')) {
        if (this.config.myCeremony['ceremony-checklist'].outcomes.hasOwnProperty('notice1Given')) {
          this.notice1Given = this.getBookingOutcomeAnswer(this.config.myCeremony['ceremony-checklist'].outcomes.notice1Given);
        }
        if (this.config.myCeremony['ceremony-checklist'].outcomes.hasOwnProperty('notice2Given')) {
          this.notice2Given = this.getBookingOutcomeAnswer(this.config.myCeremony['ceremony-checklist'].outcomes.notice2Given);
        }
      }
    }

    // Due dates
    this.giveNoticeDueDate = moment(this.booking.datetime).utc().tz('Europe/London').subtract(29, 'day').format('DD/MM/YYYY');
    this.outstandingBalanceDueDate = moment(this.booking.datetime).utc().tz('Europe/London').subtract(12, 'week').format('DD/MM/YYYY');
    this.choicesDueDate = moment(this.booking.datetime).utc().tz('Europe/London').subtract(1, 'week').format('DD/MM/YYYY');

  }

  get showGiveNotice(): boolean {
    if (this.hideGiveNoticeServiceIds.length === 0) {
      return true;
    }
    const booking = this.booking || this.dataStore.booking;
    if (!booking) {
      return true;
    }
    return !this.hideGiveNoticeServiceIds.some(
      (id: any) => Number(id) === Number(booking.service_id)
    );
  }

  getBookingOutcomeAnswer(questionId: number) {
    const answer = this.booking._embedded.answers.find((f:any) => f.question_id === questionId);
    if (answer) {
      return answer.value;
    }
    return false;
  }

}
